"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSpeedLogData;

var _invokeAppByIframe2 = _interopRequireDefault(require("@baidu/mvideo-tool/lib/invokeAppByIframe"));

var _constConfig = require("../../util/constConfig");

var _tool = require("../../util/tool");

var _getVersion = _interopRequireDefault(require("../getVersion"));

/**
 * 获取端部分耗时端能力
 * @return {Promise}
 */
function getSpeedLogData() {
  if ((0, _tool.versionCompare)((0, _getVersion.default)(), '1.8') < 0) {
    return Promise.reject(_constConfig.LOW_EXIST);
  }

  return new Promise(function (resolve, reject) {
    (0, _invokeAppByIframe2.default)("".concat(_constConfig.QUANMIN_APPNAME, "://log/getSpeedLogData"), function (result) {
      if (+result.status === 0) {
        resolve(result);
      } else {
        reject(result);
      }
    });
  });
}